import useSWRMutation from 'swr/mutation';
import {useParams, useRouteLoaderData} from 'react-router-dom';

const API_ROUTE =
  'https://admin.ethicssocioeconomics.com/api/1.0/questionnaires';

async function sendAnswersRequest([url, token], {arg}) {
  return fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: arg,
  }).then(async (res) => {
    // If the status code is not in the range 200-299,
    // we still try to parse and throw it.
    if (!res.ok) {
      const error = new Error('An error occurred while fetching the data.');
      // Attach extra info to the error object.
      error.info = await res.json();
      error.status = res.status;
      throw error;
    }

    return res.ok;
  });
}

function useSaveAnswers(user) {
  const {userSession} = useRouteLoaderData('root') || {};
  const {questionnaireModuleId} = useParams();
  const {trigger, error, isMutating, reset} = useSWRMutation(
    [
      `${API_ROUTE}/${user.questionnaireId}/modules/${questionnaireModuleId}/answers?applicantId=${user.id}`,
      userSession?.accessToken?.jwtToken,
    ],
    sendAnswersRequest
  );

  return {
    trigger,
    isMutating,
    isError: error,
    reset,
  };
}

export default useSaveAnswers;
